import _reduceInstanceProperty from "@babel/runtime-corejs3/core-js/instance/reduce";
import _includesInstanceProperty from "@babel/runtime-corejs3/core-js/instance/includes";
import { find } from "lodash";
import Vue from "vue";
export const ifCond = function (v1, v2, options) {
  return v1 == v2 ? options.fn(this) : options.inverse(this);
};
export const unlessEquals = function (v1, v2, options) {
  return v1 != v2 ? options.fn(this) : options.inverse(this);
};
export const unlessAny = function (v1, v2, v3, v4, options) {
  return v1 != v2 || v3 != v4 ? options.fn(this) : options.inverse(this);
};
export const ifAnyFilled = function (v1, v2, options) {
  return v1 || v2 ? options.fn(this) : options.inverse(this);
};
export const ifAny = function (v1, v2, v3, v4, options) {
  return v1 === v2 || v3 === v4 ? options.fn(this) : options.inverse(this);
};
export const ifAll = function (v1, v2, v3, v4, options) {
  return v1 === v2 && v3 === v4 ? options.fn(this) : options.inverse(this);
};
export const ifBothTrue = function (v1, v2, options) {
  return v1 && v2 ? options.fn(this) : options.inverse(this);
};
export const not = variable => !variable;
export const logicalAnd = (...values) => {
  return _reduceInstanceProperty(values).call(values, (a, b) => a && b, true);
};
export const logicalOr = (...values) => {
  return _reduceInstanceProperty(values).call(values, (a, b) => a || b, true);
};
export const shortCircuit = (v1, v2, v3) => v1 || v2 || v3;
export const shortCircuitAnd = (v1, v2) => v1 && v2;
export const ifNotInProgress = function (status, options) {
  const inProgresStatus = ["ready-to-close", "accepted", "approved", "in-progress", "confirmed"];
  return _includesInstanceProperty(inProgresStatus).call(inProgresStatus, status) ? options.inverse(this) : options.fn(this);
};
export const ifAccountCan = function (currentTab, session, options) {
  const {
    permissions
  } = session;
  const {
    can
  } = currentTab;
  if (can === "all") return options.fn(this);
  return permissions[can] !== "none" ? options.fn(this) : options.inverse(this);
};
export const ifHasDocuments = function (classificationType, documents, options) {
  const doc = find(documents, doc => doc.classificationType === classificationType);
  return doc ? options.fn(this) : options.inverse(this);
};
export const ifAccountPlan = (plans, session, options) => {
  const {
    accountPlan
  } = session.accountDetails;
  plans = plans.split("|");
  return _includesInstanceProperty(plans).call(plans, accountPlan) ? options.fn(this) : options.inverse(this);
};
export const applicationIsSubmitted = dbStatus => {
  return dbStatus && dbStatus !== "new" && dbStatus !== "pending";
};
export const isSessionUsername = username => username === Vue.auth.session.get().userDetails.username;
export const greaterThan = (number1, number2) => number1 > number2;
export const greaterThanEq = (number1, number2) => number1 >= number2;
export const ifObject = function (item, options) {
  return typeof item === "object" ? options.fn(this) : options.inverse(this);
};
export const eq = function (v1, v2) {
  return v1 == v2;
};
export const registerHandlebarHelpers = Handlebars => {
  Handlebars.registerHelper("ifCond", ifCond);
  Handlebars.registerHelper("unlessEquals", unlessEquals);
  Handlebars.registerHelper("unlessAny", unlessAny);
  Handlebars.registerHelper("ifAnyFilled", ifAnyFilled);
  Handlebars.registerHelper("ifAny", ifAny);
  Handlebars.registerHelper("ifAll", ifAll);
  Handlebars.registerHelper("ifBothTrue", ifBothTrue);
  Handlebars.registerHelper("not", not);
  Handlebars.registerHelper("logicalAnd", logicalAnd);
  Handlebars.registerHelper("logicalOr", logicalOr);
  Handlebars.registerHelper("shortCircuit", shortCircuit);
  Handlebars.registerHelper("shortCircuitAnd", shortCircuitAnd);
  Handlebars.registerHelper("ifNotInProgress", ifNotInProgress);
  Handlebars.registerHelper("ifAccountCan", ifAccountCan);
  Handlebars.registerHelper("ifHasDocuments", ifHasDocuments);
  Handlebars.registerHelper("ifAccountPlan", ifAccountPlan);
  Handlebars.registerHelper("applicationIsSubmitted", applicationIsSubmitted);
  Handlebars.registerHelper("isSessionUsername", username => username === Vue.auth.session.get().userDetails.username);
  Handlebars.registerHelper("greaterThan", greaterThan);
  Handlebars.registerHelper("greaterThanEq", greaterThanEq);
  Handlebars.registerHelper("ifObject", ifObject);
  Handlebars.registerHelper("eq", eq);
};